import React, { useState, useEffect, useRef } from "react"; // [EXPERT_COMMENT]: Añadida importación de useRef - Necesario para referenciar el componente Toast.
import { Dialog } from "primereact/dialog"; // [EXPERT_COMMENT]: Añadida importación de Dialog - Necesario para el componente modal.
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast"; // [EXPERT_COMMENT]: Añadida importación de Toast - Necesario para mostrar notificaciones.
import "../styles/App.css";
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

//const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const CrearCliente = ({ isOpen, onClose, language, onSave, marcasExistentes = [] }) => {
  // [EXPERT_COMMENT]: Añadidas props para modal - isOpen, onClose, onSave para controlar el modal.
  const toastCenter = useRef(null); // [EXPERT_COMMENT]: Nueva referencia para Toast - Permite mostrar notificaciones.
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    // telefono2: "", // [EXPERT_COMMENT]: Comentado: Campo telefono2 - Se comenta la inicialización del campo telefono2 para deshabilitarlo temporalmente.
    // email: "", // [EXPERT_COMMENT]: Comentado: Campo email - Se comenta la inicialización del campo email para deshabilitarlo temporalmente.
    pais: null,
    departamento: null,
    ciudad: null,
    nombrecontacto: "",
    marca: "",
  });

  const [paises, setPaises] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [errors, setErrors] = useState({}); // Manejo de errores

  // Traducciones dinámicas según el idioma
  const translations = {
    es: {
      title: "Crear Nuevo Cliente",
      name: "Nombre",
      phone1: "Teléfono 1",
      phone2: "Teléfono 2",
      // email: "Correo Electrónico", // [EXPERT_COMMENT]: Comentado: Traducción de email - Se comenta la traducción del campo email para deshabilitarlo temporalmente.
      country: "País",
      state: "Departamento",
      city: "Ciudad",
      brand: "Marca",
      submit: "Crear",
      save: "Guardar", // [EXPERT_COMMENT]: Nueva traducción para botón de guardar - Texto para el botón de guardar.
      cancel: "Cancelar", // [EXPERT_COMMENT]: Nueva traducción para botón de cancelar - Texto para el botón de cancelar.
      errors: {
        required: "Este campo es obligatorio",
        invalidEmail: "Correo electrónico inválido",
        duplicateEntry:
          "La marca ya existe. Por favor, ingrese una marca diferente.", // [EXPERT_COMMENT]: Nueva traducción para error de duplicidad - Mensaje específico para marcas duplicadas.
        unknownError: "Error desconocido", // [EXPERT_COMMENT]: Nueva traducción para error desconocido - Mensaje genérico para errores no específicos.
      },
      clientCreatedSuccess: "Cliente creado con éxito", // [EXPERT_COMMENT]: Nueva traducción para mensaje de éxito - Mensaje de confirmación de creación de cliente.
      noDepartments: "No hay departamentos disponibles", // [EXPERT_COMMENT]: Nueva traducción para mensaje de no departamentos - Mensaje para cuando no hay opciones de departamento.
      noCities: "No hay ciudades disponibles", // [EXPERT_COMMENT]: Nueva traducción para mensaje de no ciudades - Mensaje para cuando no hay opciones de ciudad.
    },
    en: {
      title: "Create New Client",
      name: "Name",
      phone1: "Phone 1",
      phone2: "Phone 2",
      // email: "Email", // [EXPERT_COMMENT]: Comentado: Traducción de email (EN) - Se comenta la traducción del campo email para deshabilitarlo temporalmente.
      country: "Country",
      state: "State",
      city: "City",
      brand: "Brand",
      submit: "Create",
      save: "Save", // [EXPERT_COMMENT]: Nueva traducción para botón de guardar (EN) - Texto para el botón de guardar.
      cancel: "Cancel", // [EXPERT_COMMENT]: Nueva traducción para botón de cancelar (EN) - Texto para el botón de cancelar.
      errors: {
        required: "This field is required",
        invalidEmail: "Invalid email address",
        duplicateEntry:
          "The brand already exists. Please enter a different brand.", // [EXPERT_COMMENT]: Nueva traducción para error de duplicidad (EN) - Mensaje específico para marcas duplicadas.
        unknownError: "Unknown error", // [EXPERT_COMMENT]: Nueva traducción para error desconocido (EN) - Mensaje genérico para errores no específicos.
      },
      clientCreatedSuccess: "Client created successfully", // [EXPERT_COMMENT]: Nueva traducción para mensaje de éxito (EN) - Mensaje de confirmación de creación de cliente.
      noDepartments: "No departments available", // [EXPERT_COMMENT]: Nueva traducción para mensaje de no departamentos (EN) - Mensaje para cuando no hay opciones de departamento.
      noCities: "No cities available", // [EXPERT_COMMENT]: Nueva traducción para mensaje de no ciudades (EN) - Mensaje para cuando no hay opciones de ciudad.
    },
    zh: {
      title: "创建新客户",
      name: "名称",
      phone1: "电话 1",
      phone2: "电话 2",
      // email: "电子邮件", // [EXPERT_COMMENT]: Comentado: Traducción de email (ZH) - Se comenta la traducción del campo email para deshabilitarlo temporalmente.
      country: "国家",
      state: "州/省",
      city: "城市",
      brand: "品牌",
      submit: "创建",
      save: "保存", // [EXPERT_COMMENT]: Nueva traducción para botón de guardar (ZH) - Texto para el botón de guardar.
      cancel: "取消", // [EXPERT_COMMENT]: Nueva traducción para botón de cancelar (ZH) - Texto para el botón de cancelar.
      errors: {
        required: "此字段为必填项",
        invalidEmail: "无效的电子邮件地址",
        duplicateEntry: "品牌已存在。请输入不同的品牌。", // [EXPERT_COMMENT]: Nueva traducción para error de duplicidad (ZH) - Mensaje específico para marcas duplicadas.
        unknownError: "未知错误", // [EXPERT_COMMENT]: Nueva traducción para error desconocido (ZH) - Mensaje genérico para errores no específicos.
      },
      clientCreatedSuccess: "客户创建成功", // [EXPERT_COMMENT]: Nueva traducción para mensaje de éxito (ZH) - Mensaje de confirmación de creación de cliente.
      noDepartments: "没有可用的部门", // [EXPERT_COMMENT]: Nueva traducción para mensaje de no departamentos (ZH) - Mensaje para cuando no hay opciones de departamento.
      noCities: "没有可用的城市", // [EXPERT_COMMENT]: Nueva traducción para mensaje de no ciudades (ZH) - Mensaje para cuando no hay opciones de ciudad.
    },
  };

  const t = translations[language] || translations.es; // Traducciones actuales

  // [EXPERT_COMMENT]: Función para mostrar mensajes Toast - Centraliza la lógica de notificación.
  const showMessage = (severity, summary, detail) => {
    if (toastCenter.current) {
      toastCenter.current.show({ severity, summary, detail, life: 3000 });
    }
  };

  // Cargar datos iniciales
  useEffect(() => {
    // Cargar países desde el backend
    fetchWithAuth(`${API_URL}/api/paises/`)
      .then((res) => res.json())
      .then((data) =>
        setPaises(
          data.map((pais) => ({ label: pais.sNombrePais, value: pais.idpais })),
        ),
      ) // [EXPERT_COMMENT]: Corrección de nombre de propiedad - Se cambia 'iCodPaises' a 'idpais' para coincidir con el alias del backend.
      .catch((err) => console.error("Error al cargar países:", err));
  }, []);

  useEffect(() => {
    if (formData.pais) {
      // Cargar departamentos según el país seleccionado
      fetchWithAuth(`${API_URL}/api/departamentos/${formData.pais}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(
              `Error al cargar departamentos: ${res.status} ${res.statusText}`,
            );
          }
          return res.json();
        })
        .then((data) => {
          setDepartamentos(
            data.map((dpto) => ({
              label: dpto.sNombreDepartamento,
              value: dpto.iddepartamento,
            })),
          ); // [EXPERT_COMMENT]: Corrección de nombres de propiedades - Se ajustan 'sNombreDpto' a 'sNombreDepartamento' y 'iCodDpto' a 'iddepartamento' para coincidir con los alias del backend.
        })
        .catch((err) => console.error(err));
    } else {
      setDepartamentos([]);
      setCiudades([]);
    }
  }, [formData.pais]);

  useEffect(() => {
    if (formData.departamento) {
      // Cargar ciudades según el departamento seleccionado
      fetchWithAuth(
        `${API_URL}/api/ciudades?departamentoId=${formData.departamento}`,
      ) // [EXPERT_ANALYSIS]: QUÉ: Se modifica la construcción de la URL para obtener ciudades. - POR QUÉ: La ruta del backend (`backend/routes/getciudades.js`) espera un parámetro de consulta `departamentoId` en lugar de un segmento de ruta. Este cambio alinea la solicitud del frontend con la API del backend, resolviendo el error 404 Not Found y el `SyntaxError` al esperar JSON. - IMPACTO: Permite que el frontend obtenga correctamente la lista de ciudades filtradas por departamento.
        .then((res) => res.json())
        //.then((data) => setCiudades(data.map((ciudad) => ({ label: ciudad.sNombreCiudad, value: value: ciudad.iCodCiudad })))) // [EXPERT_COMMENT]: Corrección de nombre de propiedad - Se cambia 'iCodCiudad' a 'idciudad' para coincidir con el alias del backend.
        .then((data) =>
          setCiudades(
            data.map((ciudad) => ({
              label: ciudad.sNombreCiudad,
              value: ciudad.iCodCiudad, // Cambiar idciudad por iCodCiudad
            })),
          ),
        )
        .catch((err) => console.error("Error al cargar ciudades:", err));
    } else {
      setCiudades([]);
    }
  }, [formData.departamento]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Limpiar el error de marca duplicada en tiempo real mientras el usuario edita el campo
    if (name === "marca") {
      setErrors((prev) => {
        const { marca, ...resto } = prev;
        return resto;
      });
    }
  };

  // Validación local al perder el foco (onBlur) para feedback inmediato
  const handleMarcaBlur = (e) => {
    const valor = e.target.value.toLowerCase().trim();
    if (marcasExistentes.includes(valor)) {
      setErrors((prev) => ({ ...prev, marca: t.errors.duplicateEntry }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nombre) newErrors.nombre = t.errors.required;
    if (!formData.telefono) newErrors.telefono = t.errors.required;
    if (!formData.pais) newErrors.pais = t.errors.required;
    if (!formData.departamento) newErrors.departamento = t.errors.required;
    if (!formData.ciudad) newErrors.ciudad = t.errors.required;
    if (!formData.marca) {
      newErrors.marca = t.errors.required;
    } else if (marcasExistentes.includes(formData.marca.toLowerCase().trim())) {
      newErrors.marca = t.errors.duplicateEntry;
    }
    /* if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      // [EXPERT_COMMENT]: Validación de email - Se añade una validación básica de formato de correo electrónico.
      newErrors.email = t.errors.invalidEmail;
    } */ // [EXPERT_COMMENT]: Comentado: Validación de email - Se comenta la lógica de validación del campo email para deshabilitarlo temporalmente.
    return newErrors;
  };

  const handleSubmit = async () => {
    // [EXPERT_COMMENT]: Eliminado 'e' y 'e.preventDefault()' - El Dialog maneja el submit sin evento de formulario.
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      const response = await fetchWithAuth(`${API_URL}/api/clientes`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          // [EXPERT_ANALYSIS]: QUÉ: Se desestructura formData y se sobrescriben los campos pais, departamento y ciudad.
          // [EXPERT_ANALYSIS]: POR QUÉ: Se corrige el tipo de dato de 'pais' y 'departamento' de ID numérico a nombre de cadena, y se asegura que 'ciudad' se envíe como ID numérico, según las expectativas del backend.
          // [EXPERT_ANALYSIS]: IMPACTO: Resuelve los errores de validación del backend, permitiendo la creación exitosa de clientes.
          ...formData,
          pais:
            paises.find((p) => p.value === formData.pais)?.label ||
            formData.pais, // [EXPERT_ANALYSIS]: QUÉ: Transforma el ID del país a su nombre. - POR QUÉ: El backend espera el nombre del país (cadena de texto), no el ID numérico. Se busca el 'label' (nombre) correspondiente al 'value' (ID) seleccionado. Si no se encuentra, se mantiene el valor original como fallback. - IMPACTO: Alinea el tipo de dato de 'pais' con la expectativa del backend.
          departamento:
            departamentos.find((d) => d.value === formData.departamento)
              ?.label || formData.departamento, // [EXPERT_ANALYSIS]: QUÉ: Transforma el ID del departamento a su nombre. - POR QUÉ: El backend espera el nombre del departamento (cadena de texto), no el ID numérico. Se busca el 'label' (nombre) correspondiente al 'value' (ID) seleccionado. Si no se encuentra, se mantiene el valor original como fallback. - IMPACTO: Alinea el tipo de dato de 'departamento' con la expectativa del backend.
          ciudad: formData.ciudad, // [EXPERT_ANALYSIS]: QUÉ: Se envía directamente el ID numérico de la ciudad. - POR QUÉ: La prop `optionValue="value"` en el Dropdown (línea 342) asegura que `formData.ciudad` ya contenga el ID numérico de la ciudad seleccionada (o `null`). Esto elimina la necesidad de transformaciones adicionales y alinea el valor con la expectativa del backend. - IMPACTO: Simplifica la lógica de envío y resuelve los errores de validación del backend para el campo `ciudad`.
          fechaCreacion: new Date().toISOString(), // [EXPERT_ANALYSIS]: QUÉ: Se mantiene la fecha de creación. - POR QUÉ: Es un campo necesario para el registro. - IMPACTO: No hay cambios en la funcionalidad de fecha.
          // email: formData.email, // [EXPERT_ANALYSIS]: Comentado: Envío de email - Se comenta el envío del campo email en el cuerpo de la solicitud para deshabilitarlo temporalmente.
        }),
      });
      if (response.ok) {
        onSave(true); // [EXPERT_COMMENT]: Modificado: Llama a onSave con indicador de éxito - Notifica al componente padre que se guardó exitosamente y que debe mostrar un mensaje de éxito.
        onClose(); // [EXPERT_COMMENT]: Cierra el modal - Cierra el modal después de guardar.
        setFormData({
          // [EXPERT_COMMENT]: Resetea el formulario - Limpia los campos después de un guardado exitoso.
          nombre: "",
          telefono: "",
          // telefono2: "", // [EXPERT_COMMENT]: Comentado: Reseteo de telefono2 - Se comenta el reseteo del campo telefono2 para deshabilitarlo temporalmente.
          // email: "", // [EXPERT_COMMENT]: Comentado: Reseteo de email - Se comenta el reseteo del campo email para deshabilitarlo temporalmente.
          pais: null,
          departamento: null,
          ciudad: null,
          marca: "",
        });
        setErrors({}); // [EXPERT_COMMENT]: Limpia errores - Resetea los errores del formulario.
      } else {
        // [EXPERT_COMMENT]: Manejo de errores de la API - Muestra un mensaje de error si la respuesta no es OK.
        const errorData = await response.json();
        console.error("Error al crear cliente:", errorData);
        // [EXPERT_COMMENT]: Manejo de error de duplicidad - Detecta el mensaje de error de clave única y muestra un mensaje específico.
        
        // Captura del conflicto 409 o mensaje de duplicidad del servidor
        if (
          response.status === 409 || 
          (errorData.error === "Error de duplicidad") ||
          (errorData.details && errorData.details.includes("Duplicate entry"))
        ) {
          // 1. Mantener modal abierto y registrar el error en el input de la marca
          setErrors((prev) => ({ ...prev, marca: t.errors.duplicateEntry }));
          
          // 2. Sincronizar marcas en memoria en segundo plano de forma silenciosa (success = false)
          if (typeof onSave === "function") {
            await onSave(false);
          }
          showMessage("error", "Error de duplicidad", t.errors.duplicateEntry);
        } else {
          // [EXPERT_COMMENT]: Muestra mensaje de error genérico - Si no es un error de duplicidad, muestra un mensaje general.
          // [EXPERT_COMMENT]: Se incluye 'errorData.details' o 'errorData.message' para proporcionar más contexto al usuario.
          showMessage(
            "error",
            "Error",
            `${errorData.message || errorData.error || t.errors.unknownError}`,
          );
        }
      }
    } catch (error) {
      console.error("Error:", error);
      showMessage(
        "error",
        "Error de red",
        `Error de red o del servidor: ${error.message}`,
      ); // [EXPERT_COMMENT]: Manejo de errores de red - Muestra un mensaje para errores de conexión o servidor.
    }
  };

  const footerContent = // [EXPERT_COMMENT]: Contenido del footer del modal - Define los botones de acción del modal.
    (
      <div>
        {/* <Button label={t.cancel} icon="pi pi-times" onClick={onClose} className="p-button-text" />{" "} */}
        {/* [EXPERT_COMMENT]: Línea original comentada por Andrés Baena - Se preserva la versión anterior que usaba un estilo de solo texto. */}
        <Button
          id="btn-crear-cliente-cancelar"
          label={t.cancel}
          icon="pi pi-times"
          onClick={onClose}
          className="p-button-secondary"
        />
        {/* [EXPERT_ANALYSIS]: QUÉ: Se ha modificado la clase del botón de 'Cancelar' de "p-button-text" a "p-button-secondary". - POR QUÉ: La clase `p-button-text` creaba una gran disparidad visual con el botón de 'Guardar'. La clase `p-button-secondary` proporciona un estilo secundario (generalmente con un fondo gris) que, si bien sigue siendo visualmente distinto del botón primario, crea una apariencia mucho más cohesiva y consistente. Esto establece una jerarquía clara (Guardar > Cancelar) sin que los botones parezcan de aplicaciones diferentes. - IMPACTO: Mejora la consistencia de la interfaz de usuario (UI) y la experiencia de usuario (UX) al presentar un conjunto de acciones visualmente armonizado. */}
        <Button
          id="btn-crear-cliente-guardar"
          label={t.save}
          icon="pi pi-check"
          onClick={handleSubmit}
          autoFocus
        />{" "}
        {/* [EXPERT_COMMENT]: Botón Guardar - Llama a handleSubmit. */}
      </div>
    );

  return (
    <>
      <Toast ref={toastCenter} position="top-center" /* baseZIndex={9999}  */ />{" "}
      {/* [EXPERT_COMMENT]: Componente Toast - Para mostrar notificaciones al usuario. */}
      {/* <Dialog header={t.title} visible={isOpen} style={{ width: "50vw" }} onHide={onClose} footer={footerContent}> */}{" "}
      {/* [EXPERT_COMMENT]: Comento la linea original para mantener un historial del cambio - El valor original hacia el modal demasiado ancho. */}
      <Dialog
        header={t.title}
        visible={isOpen}
        style={{ width: "60%", maxWidth: "350px" }}
        onHide={onClose}
        footer={footerContent}
      >
        {" "}
        {/* [EXPERT_COMMENT]: QUÉ: Se unifica el estilo del modal. POR QUÉ: Se aplica el mismo estilo que en el modal de edición ('width: "60%", maxWidth: "350px"') para garantizar que ambos modales tengan un tamaño consistente y responsive. */}{" "}
        {/* [EXPERT_COMMENT]: Componente Dialog - Envuelve el formulario para convertirlo en modal. */}
        <div className="p-fluid">
          {" "}
          {/* [EXPERT_COMMENT]: Contenedor de campos - Agrupa los campos del formulario. */}
          <div className="field-container">
            {errors.nombre && (
              <small className="p-error">{errors.nombre}</small>
            )}
            <FloatLabel>
              <InputText
                id="crear-cliente-nombre-input"
                name="nombre"
                value={formData.nombre}
                onChange={handleInputChange}
              />
              <label htmlFor="crear-cliente-nombre-input">{t.name}</label>{" "}
              {/* Usar traducción dinámica o texto plano */}
            </FloatLabel>
          </div>
          <div className="field-container">
            {errors.telefono && (
              <small className="p-error">{errors.telefono}</small>
            )}{" "}
            {/* Mensaje de error */}
            <FloatLabel>
              <InputText
                id="crear-cliente-telefono-input"
                name="telefono"
                value={formData.telefono}
                onChange={handleInputChange}
              />{" "}
              {/* [EXPERT_COMMENT]: Uso de InputMask para teléfono - Formato de entrada para números de teléfono. */}
              <label htmlFor="crear-cliente-telefono-input">{t.phone1}</label>
            </FloatLabel>
          </div>
          {/* [EXPERT_COMMENT]: Comentado: Campo telefono2 - Se comenta todo el bloque del campo telefono2 para deshabilitarlo temporalmente. */}
          {/*
          <div className="field-container">
            <FloatLabel>
              <InputText id="telefono2" name="telefono2" value={formData.telefono2} onChange={handleInputChange} />
              <label htmlFor="telefono2">{t.phone2}</label>
            </FloatLabel>
          </div>
          */}
          {/* [EXPERT_COMMENT]: Comentado: Campo email - Se comenta todo el bloque del campo email para deshabilitarlo temporalmente. */}
          {/*
          <div className="field-container">
            {errors.email && <small className="p-error">{errors.email}</small>}
            <FloatLabel>
              <InputText id="email" name="email" value={formData.email} onChange={handleInputChange} />
              <label htmlFor="email">{t.email}</label>
            </FloatLabel>
          </div>
          */}
          <div className="field-container">
            {errors.marca && (
              <small className="p-error">{errors.marca}</small>
            )}
            <FloatLabel>
              <InputText
                id="crear-cliente-marca-input"
                name="marca"
                value={formData.marca}
                onChange={handleInputChange}
                onBlur={handleMarcaBlur}
              />
              <label htmlFor="crear-cliente-marca-input">{t.brand}</label>
            </FloatLabel>
          </div>
          <div className="field-container">
            <div className="label-container">
              <label>{t.country}</label>
              {errors.pais && <small className="p-error">{errors.pais}</small>}
            </div>
            <Dropdown
              id="crear-cliente-pais-dropdown"
              value={formData.pais} // País seleccionado
              options={paises} // Opciones para países
              onChange={(e) =>
                setFormData({
                  ...formData,
                  pais: e.value,
                  departamento: null,
                  ciudad: null,
                })
              } // Actualiza país y resetea dependencias
              placeholder={t.country} // Texto del placeholder dinámico
              className="w-full md:w-14rem"
              checkmark={true} // Muestra un checkmark en el seleccionado
              highlightOnSelect={false} // Evita resaltar la opción seleccionada
            />
          </div>
          <div className="field-container">
            <div className="label-container">
              <label>{t.state}</label>
              {errors.departamento && (
                <small className="p-error">{errors.departamento}</small>
              )}
            </div>
            <Dropdown
              id="crear-cliente-departamento-dropdown"
              value={formData.departamento} // Departamento seleccionado
              options={departamentos} // Opciones para departamentos
              onChange={(e) =>
                setFormData({
                  ...formData,
                  departamento: e.value,
                  ciudad: null,
                })
              } // Actualiza departamento y resetea ciudad
              placeholder={
                departamentos.length === 0 ? t.noDepartments : t.state
              } // [EXPERT_COMMENT]: Modificado: Placeholder dinámico - Muestra mensaje si no hay departamentos.
              className="w-full md:w-14rem"
              checkmark={true} // Muestra un checkmark en el seleccionado
              highlightOnSelect={false} // Evita resaltar la opción seleccionada
              disabled={!formData.pais || departamentos.length === 0} // [EXPERT_COMMENT]: Modificado: Deshabilita si no hay país o no hay departamentos - Mejora la UX.
            />
          </div>
          <div className="field-container">
            <div className="label-container">
              <label>{t.city}</label>
              {errors.ciudad && (
                <small className="p-error">{errors.ciudad}</small>
              )}
            </div>
            <Dropdown
              id="crear-cliente-ciudad-dropdown"
              key={formData.departamento} // [EXPERT_ANALYSIS]: QUÉ: Se añade la prop `key` basada en `formData.departamento`. - POR QUÉ: Al cambiar el departamento, las opciones de ciudad se actualizan. Un `key` diferente fuerza a React a re-montar el componente `Dropdown` de `ciudad`, asegurando que su estado interno se reinicie y se sincronice correctamente con las nuevas `options` y `value`. Esto resuelve problemas donde el `onChange` no se disparaba o el valor no se actualizaba correctamente. - IMPACTO: Mejora la fiabilidad del `Dropdown` de ciudad, asegurando que siempre refleje el estado correcto y que los eventos `onChange` se disparen como se espera.
              value={formData.ciudad} // [EXPERT_ANALYSIS]: QUÉ: Se enlaza el valor del Dropdown con `formData.ciudad`. - POR QUÉ: Esto asegura que el componente refleje la ciudad seleccionada en el estado. - IMPACTO: La interfaz de usuario muestra la selección correcta.
              options={ciudades} // [EXPERT_ANALYSIS]: QUÉ: Se proporcionan las opciones de ciudades al Dropdown. - POR QUÉ: Las opciones ya están correctamente mapeadas con `label` y `value` (ID numérico) desde el backend. - IMPACTO: El usuario puede seleccionar una ciudad de la lista.
              onChange={(e) => {
                console.log("¡onChange de ciudad se ha disparado!"); // [EXPERT_ANALYSIS]: QUÉ: Se mantiene el log de depuración simple. - POR QUÉ: Para confirmar que la función `onChange` del Dropdown se está ejecutando. - IMPACTO: Ayuda a diagnosticar si el evento `onChange` se está disparando correctamente.
                console.log("Objeto de evento e:", e); // [EXPERT_ANALYSIS]: QUÉ: Se añade un log para el objeto `e` completo. - POR QUÉ: Permite inspeccionar todas las propiedades del objeto de evento que el Dropdown pasa al `onChange`, lo cual es crucial para entender por qué `e.value` es `undefined` o `null` y dónde reside el valor seleccionado. - IMPACTO: Proporciona información detallada para la depuración.
                console.log("Valor de e.value (después de log e):", e.value); // [EXPERT_ANALYSIS]: QUÉ: Se mantiene el log de depuración para `e.value`. - POR QUÉ: Para verificar el valor de `e.value` después de inspeccionar el objeto completo. - IMPACTO: Herramienta de diagnóstico para el desarrollador.
                const selectedCityValue =
                  e.value !== null && e.value !== undefined
                    ? Number(e.value)
                    : null;
                setFormData({ ...formData, ciudad: selectedCityValue });
              }}
              optionValue="value" // [EXPERT_ANALYSIS]: QUÉ: Se especifica que el valor de la opción es la propiedad `value` del objeto. - POR QUÉ: Esta prop es CRÍTICA. Indica al componente Dropdown que, al seleccionar una opción, debe extraer y almacenar la propiedad `value` (que es el ID numérico) del objeto de la opción en `formData.ciudad`, en lugar del objeto completo. Esto resuelve el problema de que `formData.ciudad` fuera `null` o un objeto incorrecto. - IMPACTO: Asegura que `formData.ciudad` contenga el ID numérico esperado por el backend, eliminando los errores de validación "La ciudad debe ser un número entero válido." y "La ciudad es obligatoria."
              placeholder={ciudades.length === 0 ? t.noCities : t.city} // [EXPERT_COMMENT]: Modificado: Placeholder dinámico - Muestra mensaje si no hay ciudades.
              className="w-full md:w-14rem"
              checkmark={true} // Muestra un checkmark en el seleccionado
              highlightOnSelect={false} // Evita resaltar la opción seleccionada
              disabled={!formData.departamento || ciudades.length === 0} // [EXPERT_COMMENT]: Modificado: Deshabilita si no hay departamento o no hay ciudades - Mejora la UX.
            />
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default CrearCliente;
